var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedIn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    ry: 6,
    fill: "#0a66c2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 19.75H4.26V9.25h3.26v10.5ZM5.89 7.82C4.85 7.82 4 6.97 4 5.93s.85-1.89 1.89-1.89 1.89.85 1.89 1.89-.85 1.89-1.89 1.89Zm13.85 11.93h-3.26v-5.11c0-1.22-.02-2.78-1.7-2.78s-1.96 1.33-1.96 2.7v5.19H9.56V9.25h3.13v1.43h.04a3.458 3.458 0 0 1 3.09-1.7c3.3 0 3.91 2.17 3.91 5v5.76Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.129919b95c77c23c091cc2b293a6b2c9.svg";
export { ForwardRef as ReactComponent };